var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTargetCenter64X64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.911,
    height: 106.499,
    viewBox: "0 0 95.911 106.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-target-center_64x64",
    "data-name": "streamline-icon-target-center@64x64",
    transform: "translate(2.548 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M29.376,39.211l18.7-18.7",
    transform: "translate(11.636 10.64)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M40.488,33.152l2.549-16.828L57.612,2l2.253,11.775L71.64,16.028,57.316,30.6Z",
    transform: "translate(19.223 -2)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M91.065,38.593A43.752,43.752,0,1,1,53.187,6.225",
    transform: "translate(-5.004 0.731)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M63.433,35.891A23.563,23.563,0,1,1,40.547,18",
    transform: "translate(3.184 8.924)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M18.742,54,15.376,67.462",
    transform: "translate(2.077 33.505)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M45.376,54l3.366,13.462",
    transform: "translate(22.561 33.505)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTargetCenter64X64);
export default __webpack_public_path__ + "static/media/streamline-icon-target-center@64x64.531bc293.svg";
export { ForwardRef as ReactComponent };